import { useParams, Link as RouterLink, } from 'react-router-dom';
import { useFirstMountState, } from 'react-use';
import {
    Alert,
    Skeleton,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemButton,
    Grid,
    Tooltip, } from '@mui/material';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import ClearIcon from '@mui/icons-material/Clear';
import { useAuth, useCollection, useFirestore, } from '../../hooks';

const ListSets = ({ sx = [], ...props }) => {
    const { id, } = useParams();
    const { user, } = useAuth();
    const { documents, isPending, error, } = useCollection({
        col: 'sets',
        _query: [['uid', '==', user.uid], ['foldersIds', 'array-contains', id]],
        _orderBy: ['createdAt', 'asc'],
    });

    const { updateArrayDocument: updateArrayFolders, response: { isPending: isPendingFirestoreFolders, } } = useFirestore('folders');
    const { updateArrayDocument: updateArraySets, response: { isPending: isPendingFirestoreSets, } } = useFirestore('sets');

    const isFirstMount = useFirstMountState();

    return (
     <>
         {
             isFirstMount
                 ? null
                 : isPending
                 ?
                     <Grid
                         container
                         spacing={1.5}
                         sx={[
                             {
                                 mt: [-4, -4.5],
                             },
                                 ...(Array.isArray(sx) ? sx : [sx]),
                             ]}>
                         {[1, 2, 3, 4, 5, 6].map((value, index, arr) => {
                             return (
                                 <Grid key={value} item xs={12} md={6}>
                                     <Skeleton
                                         animation='wave'
                                         sx={{
                                            height: ['90px', '104px', '112px'],
                                            mb: (arr.length - 1 !== index) && [-3.45, -4],
                                            width: '100%',
                                         }} />
                                 </Grid>
                             )
                         })}
                     </Grid>
                 : error
                 ? <Alert severity='error' variant='filled'>{error.message}</Alert>
                 : (documents?.length > 0) && (
                         <List
                             disablePadding
                             {...props}
                             sx={[
                                 ...(Array.isArray(sx) ? sx : [sx]),
                             ]}
                         >
                             <Grid container spacing={1.5}>
                                 {
                                     documents.map((doc) => {
                                         return (
                                             <Grid key={doc.id} item xs={12} md={6}>
                                                 <Link
                                                     component={RouterLink}
                                                     to={`/set/${doc.id}`}
                                                     underline='none'
                                                     sx={{
                                                         border: 1,
                                                         borderColor: 'borderColor.main',
                                                         display: 'flex',
                                                         height: '100%',
                                                         alignItems: 'center',
                                                         '&:hover': {
                                                             borderColor: 'secondary.main',
                                                             '& .MuiListItem-root > .MuiListItemIcon-root > .MuiSvgIcon-root': {
                                                                 color: 'secondary.main',
                                                             },
                                                             '& .MuiListItemText-primary': {
                                                                 color: 'secondary.main',
                                                             },
                                                         },
                                                     }}>
                                                     <ListItem
                                                         sx={{
                                                             px: [1.25, 1.5, 1.75, 2],
                                                             py: [0.5, 0.75, 1],
                                                         }}>
                                                         <ListItemIcon sx={{ minWidth: 'auto', mr: [1.25, 1.5, 1.75, 2], }}>
                                                             <AutoAwesomeMotionIcon sx={{
                                                                 color: 'text.primary',
                                                                 fontSize: [21, 23, 25, 27],
                                                             }} />
                                                         </ListItemIcon>
                                                         <ListItemText
                                                             primary={doc.title}
                                                             secondary={doc.description}
                                                             sx={{
                                                                 mr: 1.5,
                                                                 '& .MuiListItemText-primary': {
                                                                     color: 'text.primary',
                                                                     display: 'block',
                                                                     fontSize: [12, 13, 14],
                                                                     overflowWrap: 'anywhere',
                                                                 },
                                                                 '& .MuiListItemText-secondary': {
                                                                     fontSize: [11, 12, 13],
                                                                     overflowWrap: 'anywhere',
                                                                 },
                                                             }}
                                                         />
                                                         <Tooltip title='Удалить сет из папки' placement='top' arrow>
                                                             <ListItemButton
                                                                 disabled={isPendingFirestoreFolders || isPendingFirestoreSets}
                                                                 onClick={(e) => {
                                                                     e.preventDefault();
                                                                     updateArrayFolders(id, doc.id, 'setsIds', 'delete');
                                                                     updateArraySets(doc.id, id, 'foldersIds', 'delete');
                                                                 }}
                                                                 sx={{
                                                                     flexGrow: 0,
                                                                     p: 0,
                                                                     '&:hover': {
                                                                         '& .MuiSvgIcon-root': {
                                                                             color: 'common.darkRed',
                                                                         },
                                                                     },
                                                                 }}>
                                                                 <ListItemIcon sx={{minWidth: 'auto',}}>
                                                                     <ClearIcon sx={{fontSize: 20,}} />
                                                                 </ListItemIcon>
                                                             </ListItemButton>
                                                         </Tooltip>
                                                     </ListItem>
                                                 </Link>
                                             </Grid>
                                         )
                                     })
                                 }
                             </Grid>
                         </List>
                     )
         }
     </>
    );
};

export default ListSets;